import { __awaiter } from "tslib";
import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a11e18c8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "orderbook" };
const _hoisted_2 = {
    key: 0,
    class: "orderbook_vertical"
};
const _hoisted_3 = { class: "list_outer" };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { class: "list_outer" };
const _hoisted_6 = { key: 2 };
import OrderBookHeader from '@/components/organisms/main/trade/orderbook/OrderBookHeader.vue';
import OrderBookList from '@/components/organisms/main/trade/orderbook/OrderBookList.vue';
import { useStore } from '@/store/store';
import { useOrderBook, orderBookSubscriber } from '@/logics/orderbook';
import { onMounted, onUnmounted, watch, ref } from 'vue';
import orderBookIcon from '@/materials/atoms/OrderBookIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        base: null,
        quote: null,
        isAuth: { type: Boolean },
        latestValue: null
    },
    setup(__props) {
        return __awaiter(this, void 0, void 0, function* () {
            let __temp, __restore;
            const props = __props;
            const store = useStore();
            const { getOrderBook } = useOrderBook();
            const { buy, sell } = (([__temp, __restore] = _withAsyncContext(() => getOrderBook(store.getters.symbol.pair))),
                __temp = yield __temp,
                __restore(),
                __temp);
            const { subscribe, unsubscribe, buyList, sellList } = orderBookSubscriber(buy, sell, store.state.symbol.pair);
            onMounted(() => {
                subscribe();
                if (!props.isAuth) {
                    setTimeout(unsubscribe, process.env.VUE_APP_UNSUBSCRIBE * 1000);
                }
            });
            onUnmounted(unsubscribe);
            watch(() => store.state.openList, () => __awaiter(this, void 0, void 0, function* () {
                getOrderBook(store.getters.symbol.pair).then((res) => {
                    buyList.value = res.buy;
                    sellList.value = res.sell;
                });
            }));
            const displayKind = ref('all');
            const switchDisplay = (e) => {
                displayKind.value = e;
            };
            return (_ctx, _cache) => {
                return (_openBlock(), _createElementBlock("div", null, [
                    _createVNode(orderBookIcon, { onSwitch: switchDisplay }),
                    _createElementVNode("div", _hoisted_1, [
                        (displayKind.value === 'all')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("div", null, [
                                    _createVNode(OrderBookHeader, {
                                        quote: props.quote,
                                        base: props.base,
                                        reverse: true,
                                        "show-total": false
                                    }, null, 8, ["quote", "base"]),
                                    _createElementVNode("div", _hoisted_3, [
                                        (_unref(buyList).length !== 0)
                                            ? (_openBlock(), _createBlock(OrderBookList, {
                                                key: 0,
                                                class: "lists",
                                                list: _unref(buyList),
                                                trade: "buy",
                                                id: "buy",
                                                reverse: true,
                                                "show-total": false
                                            }, null, 8, ["list"]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createElementVNode("div", null, [
                                    _createVNode(OrderBookHeader, {
                                        quote: props.quote,
                                        base: props.base,
                                        reverse: false,
                                        "show-total": false
                                    }, null, 8, ["quote", "base"]),
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["list_outer", _unref(sellList).length === 0 ? 'lists' : ''])
                                    }, [
                                        (_unref(sellList).length !== 0)
                                            ? (_openBlock(), _createBlock(OrderBookList, {
                                                key: 0,
                                                class: "lists",
                                                list: _unref(sellList),
                                                trade: "sell",
                                                id: "sell",
                                                reverse: false,
                                                "show-total": false
                                            }, null, 8, ["list"]))
                                            : _createCommentVNode("", true)
                                    ], 2)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (displayKind.value === 'buy')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", null, [
                                    _createVNode(OrderBookHeader, {
                                        quote: props.quote,
                                        base: props.base,
                                        reverse: false,
                                        "show-total": true
                                    }, null, 8, ["quote", "base"]),
                                    _createElementVNode("div", _hoisted_5, [
                                        (_unref(buyList).length !== 0)
                                            ? (_openBlock(), _createBlock(OrderBookList, {
                                                key: 0,
                                                class: "lists",
                                                list: _unref(buyList),
                                                trade: "buy",
                                                id: "buy",
                                                reverse: false,
                                                "show-total": true
                                            }, null, 8, ["list"]))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (displayKind.value === 'sell')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("div", null, [
                                    _createVNode(OrderBookHeader, {
                                        quote: props.quote,
                                        base: props.base,
                                        reverse: false
                                    }, null, 8, ["quote", "base"]),
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["list_outer", _unref(sellList).length === 0 ? 'lists' : ''])
                                    }, [
                                        (_unref(sellList).length !== 0)
                                            ? (_openBlock(), _createBlock(OrderBookList, {
                                                key: 0,
                                                class: "lists",
                                                list: _unref(sellList),
                                                trade: "sell",
                                                id: "sell",
                                                reverse: false,
                                                "show-total": true
                                            }, null, 8, ["list"]))
                                            : _createCommentVNode("", true)
                                    ], 2)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]));
            };
        });
    }
});
